import type { ImportAdapter } from './types';
import { parseCsv } from './csv';

/**
 * The lower-cased, trimmed header cells of a CSV's first row, as a Set for
 * cheap membership checks. Empty on non-CSV / empty input. Used by the per-source
 * `detect` sniffers below.
 */
export function csvHeaderSet(text: string): Set<string> {
  const rows = parseCsv(text);
  if (rows.length === 0) return new Set();
  return new Set(rows[0].map((h) => h.trim().toLowerCase()));
}

/**
 * Pick the adapter whose `detect` claims `rawInput`, or null when none does.
 * Checks adapters in the given order and returns the first match, so callers
 * list more-specific sources before generic ones. Adapters without a `detect`
 * (generic mappers) are skipped — never auto-selected. A thrown sniffer is
 * treated as a non-match so one bad adapter can't break detection.
 */
export function detectImportAdapter(
  rawInput: string,
  adapters: ImportAdapter[],
): ImportAdapter | null {
  for (const adapter of adapters) {
    if (!adapter.detect) continue;
    try {
      if (adapter.detect(rawInput)) return adapter;
    } catch {
      /* treat a throwing sniffer as a non-match */
    }
  }
  return null;
}
